import { render, staticRenderFns } from "./CourseFolder.vue?vue&type=template&id=631654bd&scoped=true"
import script from "./CourseFolder.vue?vue&type=script&lang=js"
export * from "./CourseFolder.vue?vue&type=script&lang=js"
import style0 from "./CourseFolder.vue?vue&type=style&index=0&id=631654bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631654bd",
  null
  
)

export default component.exports